import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DatatableService } from '../../../shared/services/datatable.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DatatableComponent, DataTablePagerComponent } from '@swimlane/ngx-datatable';
import { SpringDatatablePagination } from '../../../shared/services/spring-integration/pagination/spring-datatable-pagination';
import { SpringDatatablePaginationService } from '../../../shared/services/spring-integration/pagination/spring-datatable-pagination.service';
import { HttpParams } from '@angular/common/http';
import { NotificationsService } from 'angular2-notifications';
import * as moment from 'moment';
import { EncriptyUtilService } from '../../../shared/services/encripty-util.service';
import { ListaVendasService } from './lista-vendas.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DocumentoHelper } from '../../../shared/utils/documento.helper';


@Component({
  selector: 'ngx-lista-vendas',
  templateUrl: './lista-vendas.component.html',
  styleUrls: ['./lista-vendas.component.scss']
})
export class ListaVendasComponent implements OnInit {

  @ViewChild('myTable', { static: false })
  public myTable: DatatableComponent;
  @ViewChild('tablePager', { static: false })
  public tablePager: DataTablePagerComponent;
  public datatablePagination: SpringDatatablePagination = new SpringDatatablePagination();

  public formListaVendas = null;
  public cnpjCpf = null;
  public tableLimit = 12;
  public rowData: any;
  public tipoReuso = null;
  public customLogin = null;

  constructor(
    private formBuilder: FormBuilder,
    private datatableService: DatatableService,
    private router: Router,
    private route: ActivatedRoute,
    private encriptyService: EncriptyUtilService,
    private paginationService: SpringDatatablePaginationService,
    private service: ListaVendasService,
    private spinnerService: NgxSpinnerService,
    private notifications: NotificationsService,
  ) {

    this.paginationService.setDatatablePagination(this.datatablePagination);

  }

  getCpfCnpjMask(): string {
    const ctrl = this.formListaVendas && this.formListaVendas.get('cnpjCpf');
    const doForm = ctrl ? ctrl.value : null;
    const raw =
      this.cnpjCpf != null && String(this.cnpjCpf).trim() !== ''
        ? this.cnpjCpf
        : doForm;
    return DocumentoHelper.getMascaraCpfCnpj(raw);
  }

  formatarDocumento(valor: string | null | undefined): string {
    return DocumentoHelper.formatarDocumento(valor);
  }

  opencadastro() {

    let params: any = {
      'isRegister': this.encriptyService.encriptyBySecretKey('S'),
    };
    this.router.navigate(['../cadastrar-vendas'], { relativeTo: this.route, queryParams: params });

  }

  gotoEdit(data) {

    let id: any = this.encriptyService.encriptyBySecretKey('' + data.id);
    const cpfCnpjNorm = this.normalizarCnpjCpfParaBackend(data.cpfCnpj);
    let cpfCnpj: any = this.encriptyService.encriptyBySecretKey('' + cpfCnpjNorm);
    let isRegister: any = this.encriptyService.encriptyBySecretKey('N');

    let params: any = {
      'isRegister': isRegister,
      'id': id,
      'cpfCnpj': cpfCnpj,
    };

    this.router.navigate(['../cadastrar-vendas'], { relativeTo: this.route, queryParams: params });

  }

  gotoCancelar(data) {

    let params = new HttpParams();

    const cpfNorm = this.normalizarCnpjCpfParaBackend(data.cpfCnpj);
    params = params.append('cpfCnpj', cpfNorm);
    params = params.append('id', data.id);

    this.spinnerService.show();

    this.service.inativarReuso(params, (response) => {

      this.notifications.success(response.message);
      this.spinnerService.hide();

      if (this.tablePager._page === 1) {
        this.pesquisaVendas(this.formListaVendas.value, null);
      } else {
        this.pesquisaVendas(this.formListaVendas.value, this.tablePager._page);
      }

    }, (error) => {
      this.spinnerService.hide();
      this.notifications.error(error.message);
    });

  }

  pesquisaVendas(data: any, page?: any) {

    let params = new HttpParams();

    const docNorm = this.normalizarCnpjCpfParaBackend(data.cnpjCpf);
    if (docNorm !== '') {
      params = params.append('cpfCnpj', docNorm);
    }

    params = params.append('size', String(this.tableLimit));

    if (page && page != null) {
      params = params.append('page', page);
    }


    this.spinnerService.show();

    this.service.retornaFornecedor(params, (response) => {

      this.rowData = response.content;
      this.rowData = this.rowData.map((data) => {
        return {
          id: data.id,
          cpfCnpj: data.cpfCnpj,
          razaoSocial: data.razaoSocial,
          valor: data.valor,
          tipoReuso: data.tipoReuso,
          dataReuso: moment(data.dataReuso).format('DD/MM/YYYY'),
          status: data.status,
        };

      });
      this.spinnerService.hide();
      this.paginationService.setInfo(response);

    }, (error) => {
      this.spinnerService.hide();
      this.notifications.error(error.message);
    });

  }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.datatableService.subscribeTable(this.myTable);

    this.formListaVendas = this.formBuilder.group({

      cnpjCpf: [null],

    });
  }

  previousPage() {
    this.router.navigate(['/iot-dashboard']);
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

  private normalizarCnpjCpfParaBackend(value: any): string {
    if (value == null) {
      return '';
    }
    const str = String(value);
    if (str === '') {
      return '';
    }
    const tipo = DocumentoHelper.detectarTipoDocumento(str);
    return DocumentoHelper.normalizarParaEnvio(str, tipo);
  }

}
